import { render, staticRenderFns } from "./hospital-detail.vue?vue&type=template&id=1f8277d8&"
import script from "./hospital-detail.vue?vue&type=script&lang=js&"
export * from "./hospital-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports